import {CoreMenu} from '@core/types';

export const menu: CoreMenu[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'MENU.DASHBOARD',
        type: 'item',
        icon: 'fas fa-sign',
        url: 'dashboard',
        availableTo: ['USER']
    },
    {
        id: 'packages',
        title: 'Packages',
        translate: 'MENU.PACKAGES',
        type: 'item',
        icon: 'fa fa-shopping-bag',
        url: 'packages',
        availableTo: ['USER']
    },
    {
        id: 'products',
        title: 'Products',
        translate: 'MENU.PRODUCTS',
        type: 'item',
        icon: 'fa fa-shopping-cart',
        url: 'products',
        availableTo: ['USER']
    },
    {
        id: 'network',
        title: 'Network',
        translate: 'MENU.NETWORK.COLLAPSIBLE',
        type: 'collapsible',
        availableTo: ['USER'],
        icon: 'users',
        children: [
            {
                id: 'members',
                title: 'Members',
                translate: 'MENU.NETWORK.MEMBERS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'members'
            },
            {
                id: 'my-members',
                title: 'Direct Referrals',
                translate: 'MENU.NETWORK.MY_MEMBERS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'my-members'
            },
        ],
    },
    {
        id: 'orders',
        title: 'Orders',
        translate: 'MENU.ORDERS.COLLAPSIBLE',
        type: 'collapsible',
        availableTo: ['USER'],
        icon: 'box',
        children: [
            {
                id: 'products-orders',
                title: 'Product Orders',
                translate: 'MENU.ORDERS.PRODUCTS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'product-orders'
            },
            {
                id: 'package-orders',
                title: 'Package Orders',
                translate: 'MENU.ORDERS.PACKAGES',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'package-orders'
            }
        ],
    },
    {
        id: 'earnings',
        title: 'Earnings',
        translate: 'MENU.EARNING.COLLAPSIBLE',
        type: 'collapsible',
        availableTo: ['USER'],
        icon: 'credit-card',
        children: [
            {
                id: 'pairing-bonus',
                title: 'Pairing Bonus',
                translate: 'MENU.EARNING.PAIRING_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'pairing-bonus'
            },
            {
                id: 'self-repurchase-bonus',
                title: 'Self Repurchase Bonus',
                translate: 'MENU.EARNING.SELF_REPURCHASE_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'self-repurchase-bonus'
            },
            {
                id: 'performance-bonus',
                title: 'Performance Bonus',
                translate: 'MENU.EARNING.PERFORMANCE_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'performance-bonus'
            },
            {
                id: 'director-bonus',
                title: 'Director Bonus',
                translate: 'MENU.EARNING.DIRECTOR_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'director-bonus'
            },
            {
                id: 'leadership-bonus',
                title: 'Leadership Bonus',
                translate: 'MENU.EARNING.LEADERSHIP_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'leadership-bonus'
            },
            {
                id: 'car-fund-bonus',
                title: 'Car Fund Bonus',
                translate: 'MENU.EARNING.CAR_FUND_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'car-fund-bonus'
            },
            {
                id: 'house-fund-bonus',
                title: 'House Fund Bonus',
                translate: 'MENU.EARNING.HOUSE_FUND_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'house-fund-bonus'
            },
            {
                id: 'tour-fund-bonus',
                title: 'Tour Fund Bonus',
                translate: 'MENU.EARNING.TOUR_FUND_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'tour-fund-bonus'
            },
            /*{
                id: 'counseling-bonus',
                title: 'Conseling Bonus',
                translate: 'MENU.EARNING.CONSELING_BONUS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'counseling-bonus'
            },
            {
                id: 'performance-bonus-overview',
                title: 'Performance Bonus Overview',
                translate: 'MENU.EARNING.PERFORMANCE_BONUS_OVERVIEW',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'performance-bonus-overview'
            },*/
        ],
    },
    {
        id: 'support-tickets',
        title: 'Support',
        translate: 'MENU.SUPPORT_TICKETS',
        type: 'item',
        icon: 'fa fa-question-circle',
        url: 'support-tickets',
        availableTo: ['USER']
    },
    {
        id: 'announcement',
        title: 'Announcement',
        translate: 'MENU.ANNOUNCEMENT',
        type: 'item',
        icon: 'fas fa-bullhorn',
        url: 'announcement',
        availableTo: ['USER']
    }
];
